// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const setDaysDiffrence = goalDate => {
    return {
        type: actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_SET_DAYS_DIFF,
        payload: {
            goalDate,
        },
    };
};

const requestProjectionChartInProgress = () => ({
    type: actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_REQUEST,
});

const successProjectionChart = data => ({
    type: actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_SUCCESS,
    payload: { data },
});

const failureProjectionChart = data => ({
    type: actionTypes.RA_OBJ_TRACKING_PROJECTION_CHART_FAILURE,
    payload: { data },
});

const requestProjectionChart = portfolioId => (dispatch, getState) => {
    const {
        raObjectiveDetailsReducer,
        raProjectionChartOjectiveTrackingReducer,
    } = getState();
    const contributionAmount = raObjectiveDetailsReducer.getIn([
        'periodicTransfer',
        'amount',
    ]);
    const periodicity = raObjectiveDetailsReducer.getIn([
        'periodicTransfer',
        'periodicity',
    ]);
    const frequency = periodicity ? periodicity : 1;
    const yearsDifference = raProjectionChartOjectiveTrackingReducer.get(
        'yearDiff',
    );
    const dataPoints = raProjectionChartOjectiveTrackingReducer.get(
        'noOfChartPoints',
    );
    const params = {
        dataPoints,
        years: yearsDifference,
        mntPayment: contributionAmount,
        freq: frequency,
        portfolioId,
    };
    dispatch(requestProjectionChartInProgress());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raObjectiveTrackingProjectionChart', params),
    )
        .then(response => {
            dispatch(successProjectionChart(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(failureProjectionChart(error.error.description));
            } else {
                throw error;
            }
        });
};

module.exports = {
    requestProjectionChart,
    setDaysDiffrence,
};
